import React, { useState, useRef } from 'react';
import Select, { components } from "react-select";
import { Form } from "react-bootstrap";

const CustomSelect = ({ name, label, options, value, onChange, isMulti = false, placeholder, isRequired = false, description = "", titlePrefix, isClearable = false }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const containerRef = useRef(null);

    const CheckboxOption = (props) => {
        return (
            <components.Option {...props} className="d-flex align-items-center p-2">
                <input
                    type="checkbox"
                    className='customCheckbox'
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: '0.5rem' }}
                />
                <label className="d-flex align-items-center mb-0" style={{ color: "#161616", fontSize: "0.875rem", fontWeight: "400" }}>{props.label}</label>
            </components.Option>
        );
    };
    const customStyles = {
        control: (base) => ({
            ...base,
            background: 'transparent',
            display: 'flex',
            fontSize: "0.875rem",
            height: "2rem",
            lineHeight: "2rem",
            borderRadius: 10,
            boxShadow: "none",
            color: "#aaaaaa",
            borderColor: '#cccccc',
            '&:hover': { borderColor: '#cccccc' },
            cursor: 'pointer',
        }),
        valueContainer: (base) => ({
            ...base,
            height: "2rem",
            display: "flex",
            flexWrap: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        multiValue: (base) => ({
            ...base,
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center"
        }),
        multiValueLabel: (base) => ({
            ...base,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "6.25rem"
        }),
    };

    const handleClick = () => {
        setMenuIsOpen((prev) => !prev);
    };

    const handleChange = (value, action) => {
        onChange(value, action);
        setMenuIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setMenuIsOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const controlClassName = value && value.length > 0 ? 'has-multiple-values' : '';

    return (
        <Form.Group className='mb-3'>
            {label ? <Form.Label className='custom-label'>{label} {isRequired ? <span className="text-danger">*</span> : ''}</Form.Label> : null}
            <div ref={containerRef} onClick={handleClick} className='customSelectInput'>
                <Select
                    classNamePrefix={`react-select`}
                    className={controlClassName}
                    name={name}
                    onChange={handleChange}
                    options={options}
                    value={value}
                    isClearable={isClearable}
                    isMulti={isMulti}
                    aria-label="Select"
                    styles={customStyles}
                    placeholder={placeholder}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    menuIsOpen={menuIsOpen}
                    components={{
                        Option: CheckboxOption,
                        ValueContainer: ({ children, ...props }) => {
                            const { getValue, hasValue, isMulti, options } = props;
                            let displayText = getValue()?.map(v => v.label).join(", ") || "";
                            if (isMulti && getValue().length === options.length && (options[0]?.value === -1)) {
                                displayText = 'All';
                            }
                            const formattedDisplayText = displayText ? `${titlePrefix} : ${displayText}` : "";

                            const newProps = {  ...props,
                                innerProps: { ...props.innerProps, title: displayText }
                            };

                            if (!hasValue || !isMulti) {
                                return (
                                    <components.ValueContainer {...newProps}>
                                        {children}
                                    </components.ValueContainer>
                                );
                            }

                            return (
                                <components.ValueContainer {...props}>
                                    <div className="selected-values" title={displayText}>
                                        {formattedDisplayText}
                                    </div>
                                </components.ValueContainer>
                            );
                        },
                        IndicatorSeparator: () => null
                    }} />
            </div>
            {description && <Form.Text className='text-hint' style={{ whiteSpace: "pre-wrap" }}>
                <i className="fa fa-info-circle" aria-hidden="true" style={{ backgroundColor: 'black', color: "white", borderRadius: "50%" }}></i>&nbsp;{description}
            </Form.Text>}
        </Form.Group>
    );
}

export default CustomSelect;
